<template>
  <OnexAlert
    :type="Notifications.warning"
    :icon="mdiAlert"
    class="mt-4"
    id="crc-alert"
    elevation="0"
  >
    {{ $t('L_your_adult_child_coverage_expires') }}
    <template #description>
      <OnexButton variant="text" @click="startNewPolicy" color="accent">
        {{ $t('L_start_a_new_policy_for_adult_child') }}
      </OnexButton>
    </template>
  </OnexAlert>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { mapActions, mapState, mapStores } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { useChildRiderStore } from '../../store/childrider.store';
import { RouteNames } from '@/router/routeNames';
import { Notifications, OnexAlert, OnexButton } from '@primerica/onex-ui-lib';
import { mdiAlert } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'ChildRiderAlert',
  components: {
    OnexAlert,
    OnexButton,
  },
  data() {
    return {
      Notifications,
      mdiAlert,
    };
  },
  props: {
    indexPolicy: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(useGlobalStore, ['containsFeature']),
  },
  methods: {
    ...mapActions(useChildRiderStore, {
      crcStart: 'crcStart',
    }),
    async startNewPolicy() {
      if (this.indexPolicy !== -1) {
        await this.policyStore.changePolicy({ selectedIndex: this.indexPolicy });
      }
      await this.crcStart().then(() => {
        this.$router.push({ name: RouteNames.CHILD_RIDER });
      });
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss">
.font-size--13 {
  font-size: 13px !important;
}
.full_width {
  width: 100% !important;
}
#crc-alert .onex-alert__description .v-btn:not(.v-btn--icon) {
  float: unset;
}
#crc-alert .onex-alert__description .v-btn:not(.v-btn--icon).v-btn--variant-text {
  padding: unset;
}
#crc-alert .onex-alert__description .v-btn.v-btn--variant-text .v-btn__content {
  white-space: normal;
  text-align: left;
}
</style>
